import { Box, Typography} from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";

const ProfileSalaryInfo = ({ address }) => (
  <Box>
    <Typography variant="h6" color="text.secondary" gutterBottom>
      Address
    </Typography>
    <Box sx={{ display: "flex", alignItems: "center", pl: 2 }}>
      <HomeIcon color="action" sx={{ mr: 1.5 }} />
      <Typography>{address}</Typography>
    </Box>
  </Box>
);

export default ProfileSalaryInfo;
